<template>
    <div class="page_title_area">
        单位管理
    </div>
</template>

<script>
import mixins from "./Mixins";
export default {
mixins:[mixins],
mounted(){
    this.setLeftMenuShow_M(true);
    this.setLeftMenuIndex_M(1);
    
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/PartI/UnitManagement/components/unitTitle.vue